<div class="digit-container">
  <div class="digit-values" [style.top.px]="top">
    <div *ngFor="let digitValue of digitValues" class="digit">{{digitValue}}</div>
  </div>
</div>